import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ariaValue',
  standalone: false
})
export class AriaValuePipe implements PipeTransform {
  transform(value: string, name?: string): string {
    if (typeof value !== 'string') {
      return value;
    }

    switch (this.whichTransform(name)) {
      case 'split_digits':
        return this.splitDigits(value);
      default:
        return value;
    }
  }

  /**
   * stabilisce quale tipo trasformazione applicare in base al nome
   */
  private whichTransform(name: string): 'split_digits' | null {
    if (typeof name !== 'string' || !name) {
      return null;
    }

    name = name.toLocaleUpperCase();

    if (
      name.includes('CELL') ||
      name.includes('PHONE') ||
      name.includes('ZIP') ||
      name.includes('CAP')
    ) {
      return 'split_digits';
    } else {
      return null;
    }
  }

  /**
   * divide i numeri vicini con uno spazio in modo da farli leggere come cifre
   * separate dallo screen reader
   */
  private splitDigits(value: string): string {
    const chars = value.split('');

    return chars.reduce(
      (str: string, char: string, index: number, arr: string[]) => {
        if (this.isNumeric(char) && this.isNumeric(arr[index + 1])) {
          return str + char + ' ';
        } else {
          return str + char;
        }
      },
      ''
    );
  }

  /**
   * controlla se il carattere è numerico
   */
  private isNumeric(char: string): boolean {
    return typeof char === 'string' && /^\d+$/.test(char);
  }
}
